<template>
  <UiAlertDialog>
    <UiAlertDialogContent class="!rounded-[20px] border-0 bg-black p-12">
      <UltraContainerGradient />
      <button class="absolute right-4 top-4" @click="$emit('cancel')">
        <X class="h-4 w-4" />
        <span class="sr-only">Close</span>
      </button>
      <UiAlertDialogHeader class="relative flex items-center justify-center">
        <div
          class="row-gap-4 mb-6 flex w-[270px] flex-wrap-reverse items-center justify-center gap-[32px]"
        >
          <template v-for="icon in platformIcons" :key="icon.name">
            <Icon
              v-if="typeof icon.icon === 'string'"
              :name="icon.icon"
              :class="icon.iconClass"
              size="2.5em"
            />
            <component
              v-else
              :is="icon.icon"
              :class="icon.iconClass"
              class="h-[2.5em] w-[2.5em]"
            />
          </template>
        </div>
        <UiTypography
          class="mb-4 inline-flex items-center gap-2 text-center font-normal"
          variant="h3"
        >
          You need <IconUltra class="h-5 w-5" /> Ultra to proceed!
        </UiTypography>
        <UiAlertDialogDescription class="text-text-secondary mb-4 text-center">
          Access thousands of professional overlays, multistream across
          platforms, and upgrade your stream with Streamlabs Ultra
        </UiAlertDialogDescription>
      </UiAlertDialogHeader>
      <UiAlertDialogFooter>
        <div class="flex w-full justify-center">
          <Button
            class="rounded-full px-12 py-4"
            size="lg"
            @click="openUltraCheckout"
          >
            {{ $t("Join Ultra") }}
          </Button>
        </div>
      </UiAlertDialogFooter>
    </UiAlertDialogContent>
  </UiAlertDialog>
</template>

<script setup lang="ts">
import { openBrowserTo } from '~/lib/bindings';
import { getUltraUrl } from '~/lib/ultra';
import type { DialogProps } from '~/stores/dialogs.store';
import { X } from 'lucide-vue-next';
const { t: $t } = useI18n();

const emit = defineEmits(['cancel']);

type Props = DialogProps['ULTRA_REQUIRED'];

const props = defineProps<Props>();

const openUltraCheckout = () => {
  openBrowserTo(getUltraUrl(props.params));
  emit('cancel');
};

const { platformConfigs } = useMultistreamStore();
const platformIcons = computed(() => {
  const order = [
    'facebook',
    'twitter',
    'kick',
    'trovo',
    'twitch',
    'youtube',
    'tiktok',
  ];
  const icons = Object.entries(platformConfigs)
    .filter(([key]) => order.includes(key))
    .map(([key, value]) => ({
      icon: value.icon,
      iconClass: value.iconClass,
      name: key,
    }));
  return icons.sort((a, b) => {
    return order.indexOf(a.name) - order.indexOf(b.name);
  });
});
</script>
